import { render } from "./CollectionList.vue?vue&type=template&id=28fc9bde&scoped=true&ts=true"
import script from "./CollectionList.vue?vue&type=script&lang=ts"
export * from "./CollectionList.vue?vue&type=script&lang=ts"

import "./CollectionList.vue?vue&type=style&index=0&id=28fc9bde&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28fc9bde"]])

export default __exports__